var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-toolbar',{staticClass:"page_toolbar",staticStyle:{"max-height":"65px"},attrs:{"dark":"","flat":""}},[_c('v-toolbar-title',[_c('v-icon',{attrs:{"left":""}},[_vm._v("fas fa-glasses")]),_vm._v(" "+_vm._s(_vm.$t("common.equipment"))+" ")],1)],1),_vm._v(" VisionX Equipment Store goes here ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }